//const mode = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') ? 'development' : 'production'
const testSite = window.GLOBAL_CONFIGURATION.API_HOST[window.location.hostname].dev
//export const configuration = window.GLOBAL_CONFIGURATION[mode]
// Get API url from config.js file.
export const API =  window.GLOBAL_CONFIGURATION.API_HOST[window.location.hostname].url;
// Get portal token
export const PortalToken = window.GLOBAL_CONFIGURATION.portalToken

export const MUI_LICENSE_KEY = '419164fe34e7fb10e5ed0af765b6556fTz0xMTI1NzIsRT0xNzgwMTg1NTk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y'

export const Languages = {
	EL: 'el',
	EN: 'en',
}

export const TimeUnitsIds = {
	Days: 1,
	Min: 2,
	Hours: 3
}

export const API_ENDPOINTS = {

	portalLogin: {
		development: 'api/portalLoginDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=UYxgIOlHna9647fxsE12iI3lw6dDgIHRBVK4LEbr8Q8',
		production: 'api/portalLogin?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=oWj6TE9vELzRJf3LyO_8AEcLC8ReMuqxm-k1R0zaHlQ',
	},
	requests: {
		development: 'api/requestsDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=IzRUcrvl_FDdr_jzmSv-Q21foKV-OxVxhZTlXnRXwW8',
		production: 'api/requests?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yUYf2Tecfp--WYyR0oVKBTesGikmo-vAIF4CvGiK8mk'
	},
	applicantRegistration:{
		development: 'api/applicantRegistrationDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=fU1njsQZQOXIOgJoI1_Q0bGVCZinAdFKE1CqxCKyfbY',
		production: 'api/applicantRegistration?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=9rJ5rm-bVA_5FDsqknMmCwUExdcYdUQlbg9w_C9MSzU'
	},
	counties: {
		development: 'api/countiesDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=vE5HtYINF77E5pWRhh0YbCUs-P3vaqOaBxss-Iyk_OU',
		production: 'api/counties?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=G4lBPO4zNVnLfO3-ilWGQq-gpJMFC0SXtdTNKa4Vrww',
	},
	countries: {
		development: 'api/countriesDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=uV8nF7idEnOl6Zml_1ROyKoj-AG2u6tRF272FP6oFzA',
		production: 'api/countries?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=SBHHmfcOXRNdNDh3q8YSpBD_ZTd2QgJZhngn99iBEiw',
	},
	currencies: {
		development: 'api/currenciesDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=0iu8WFC9jt6EibZCECTCz5eZWyQb3TYntmJjW_M2KrA',
		production: 'api/currencies?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=zgiGNmfmY96qurOXSM9Acfj8jiRvRJ9HgYHlBXfAorw',
	},
	findOrganization: {
		development: 'api/findOrganizationDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=9PSmvywNaf33jNmThSqNEhVANGaWC07nvl6S8B-cV-E',
		production: 'api/findOrganization?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=0rFzbPxGZyOV93bW9A9CS0viskCHgL8BYShI7niDSeQ',
	},
	createRequest: {
		development: 'api/createRequestDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=8Jm0jEy5RZpW9GXR0FFl_GsVq0PM9vE2bBlb_tx_1ik',
		production: 'api/createRequest?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=CF8dRApu6WxeU8sOGIjo8YF02ZPjnPaB-B2sOADh1hI',
	},
	requestDocuments: {
		development: 'api/requestDocumentsDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Z3jkUTydb2G3wwfvLdbmyK0HHIso5rihSSWQDb4cBAU',
		production: 'api/requestDocuments?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=o8XmjIbT5FIhYkBgvP5izhK4n_xyuhd0tBDttCwFvYQ',
	},
	requestDocumentsList: {
		development: 'api/requestDocumentsListDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=tkPT6Tz_zCAyiD957rN1JAhCj00bEvy7ofYRmYle0EA',
		production: 'api/requestDocumentsList?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=-2198KM6owd5zTtGyIZY-3uH631Dxc_NcQ9HekcKYv0',
	},
	requestNumber: {
		development: 'api/requestNumberDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=ZX_5YACnjIWYeaLxsZnYJYCLEHy9D27gU_6keuEcpg0',
		production: 'api/requestNumber?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=EQfRBsvzSBWcBOKA9HsR09A_Iy0PkaQXqnxq6wOOiyc',
	},
	applicantMobileVerification: {
		development: 'api/applicantMobileVerificationDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=M9-bPoB4ycpW8YkBzzuB-ejGzL33WHpho41QK-KKKWU',
		production: 'api/applicantMobileVerification?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=nE0vD32-I6Aiw541aSo_Na1HKmrYE5LhGLXGrHD9dAU',
	},
	deleteApplicant: {
		development: 'api/deleteApplicantDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=4aZ5Z7CAl-ea_GkmgVfOvWm7LD1Mg0JwzYHQY-F07k4',
		production: 'api/deleteApplicant?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=SVTDaS9ntP_VM_GXZnOz5HXIRkj2F8CqiePJZf-sNlM',
	},
	retainOldApplicant: {
		development: 'api/retainOldApplicantDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Ub-stO_sR39YPU0sJnJd-cpEc31WolPXZJIrbc5nAsg',
		production: 'api/retainOldApplicant?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=pBUhFjgr7LYNZNfvM_GTShLlndESCSP5ThuW5q17gAI',
	},
	initialChangePassword: {
		development: 'api/initialChangePasswordDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=TlCCrWeHpgp_GPZ5y5phQPwkoodtiNfOicI48HvyYjA',
		production: 'api/initialChangePassword?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=0W_-19ddZ253QX99jx3pSenvj8SBdV6Ds9mvA6WvCTE',
	},
	changePassword: {
		development: 'api/changePasswordDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=sIc5_8zPYtdJNeYHyccbNCixvShIlJzhqwzKpfL3SrM',
		production: 'api/changePassword?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=JHfEyVVmnk1t842FhlmJcOsat8cOL_WLpw7Hn5IaZAw',
	},
	checkEmailOrPhoneExistence: {
		development: 'api/checkEmailOrPhoneExistenceDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=yT8gpejmliI6w47E-Iz5CXrsxmGYHwQDSEKhYoGLyN4',
		production: 'api/checkEmailOrPhoneExistence?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=5GjonsjGFPySxShUk6GqHQTRWSDYwxLBMzPNS4GhrA8',
	},
	requestLog: {
		development: 'api/requestLogDev?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=2gVyG6ITXoieH1_dkj-NlyABsqXL0NUgOvDMhLUKHPA',
		production: 'api/requestLog?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=GjiHeKLiP0jK97CdTtfYp04zjfRnnpV0dJ0I9BHsGD8',
	}
}

export const getEndPoint = (endpoint) => {
	const mode1 = testSite ? 'development' : 'production';
	const finalUrl = `${API}/${API_ENDPOINTS[endpoint][mode1]}`;
	// console.log('hostname:', window.location.hostname);
	// console.log('testSite:', testSite);
	// console.log('mode:', mode1);
	// console.log('endpoint:', endpoint);
	// console.log('finalUrl:', finalUrl);
	return finalUrl;
}
console.log("GLOBAL_CONFIGURATION:", window.GLOBAL_CONFIGURATION);
